<template>
  <v-container grid-list-lg>
    <div>
      <span><v-icon color="red">whatshot</v-icon></span>
      <span class="headline green--text" style="font-weight: 700;">Latest News</span>
    </div>
    <v-layout row wrap>
      <v-flex xs12 md8 v-for="(item, i) in news" :key="i">
        <div v-if="item.image_url" >
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md4>
                <img
                  :src="item.image_url"
                  height="150px"
                />
              </v-flex>
              <v-flex xs12 md8>
                <div>
                  <div class="headline">{{ item.news_title }}</div>
                  <div>
                    {{ item.news_content.substr(0,150) + '...' }}
                    <router-link :to="'/news/' + item.news_id">See More</router-link>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <!-- IF NO IMAGE URL -->
        <div v-else>
          <div class="headline">{{item.news_title}}</div>
          <div>
            {{ item.news_content.substr(0,150) + '...' }}
            <router-link :to="'/news/' + item.news_id">See More</router-link>
          </div>
        </div>
        <v-divider class="mt-2"></v-divider>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  data(){
    return {
      news: [],
      loaded: false
    }
  },
  async created(){
    try{
      let result = await axios.get('/api/news')
      this.news = result.data
      this.loaded = true
    }catch(e){
      console.log(e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/News.vue